import { useMarketsContext } from '@talos/kyoko';

export function MarketNames({ markets }: { markets: string[] }) {
  const { marketDisplayNameByName } = useMarketsContext();
  return <>{markets.map(market => marketDisplayNameByName.get(market) ?? market).join(', ')}</>;
}
